module.exports = __webpack_public_path__ + "img/undraw_programmer_imem.90dd4f32.svg";